module.exports = __webpack_public_path__ + "static/media/ls.fac1d814.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ls.svg
// module id = 177
// module chunks = 0